<div class="note-data flex flex-col gap-3" [ngClass]="blockClass()" (click)="openNoteForm()" role="button">
    <p class="mb-0 flex justify-between items-center" [ngClass]="{'!hidden': !show().includes('label') || !isLabel()}">
        <span class="entity-badge text-12-400 color-7">{{ ss.t('common_note') }}</span>
        <span class="text-12-400 color-7 mb-0 whitespace-nowrap" [ngClass]="{'!hidden': !show().includes('deletedAt')}">{{
            lastUpdatedByService.getDeletedAtText(noteData().deletedAt) }}</span>
    </p>
    <div class="flex flex-col gap-2">
        <div class="flex justify-between items-start">
            <div class="flex items-center gap-1">
                <!-- User avatar (if shared note) -->
                <app-me-user-avatar [uid]="noteData().uid" size="small"
                    *ngIf="noteData().uid !== cc.user.uid"></app-me-user-avatar>
                <!-- Public indicator -->
                <app-public-indicator *ngIf="noteData().isPublic" class="inline-flex"></app-public-indicator>
                <!-- Title -->
                <p class="text-16-400 color-8 mb-0">{{ noteData().title }}</p>
            </div>
        </div>
        <p class="text-12-400 color-7 mb-0"
            [ngClass]="{'!hidden': descriptionType() === 'none' || !noteData().description}">
            {{ noteData().description | parseText: descriptionType() === 'short' ? 'short' : 'full' }}</p>
    </div>
    <p class="text-12-400 color-7 mb-0 flex items-center"
        [ngClass]="{'!hidden': !show().includes('mood') || (noteData().emotion !== 0 && !noteData().emotion)}">
        <app-svg [name]="moodEmojiMap()[noteData().emotion]" [color]="ss.theme().color22" class="pe-1"
            width="12" height="12"></app-svg>{{ moodMap()[noteData().emotion] }}
    </p>
    <div class="flex flex-wrap gap-3"
        [ngClass]="{'!hidden': !lastUpdatedAtText() && !show().includes('attachments') && !show().includes('collaboratorsCount') && !show().includes('access') }">
        <div class="inline-flex items-center gap-1.5" *ngIf="lastUpdatedAtText()">
            <app-svg *ngIf="hasLastUpdatedByUid()" name="updatedatUpdatedbyMetadata" [color]="ss.theme().color7"
                width="12" height="12"></app-svg>
            <span class="text-12-400 color-7">{{ lastUpdatedAtText() }}</span>
        </div>
        <div class="inline-flex items-center gap-1.5"
            [ngClass]="{'!hidden': !show().includes('attachments') || attachments().length === 0}">
            <app-svg name="attachment" [color]="ss.theme().color7" width="12" height="12"></app-svg>
            <span class="text-12-400 color-7">{{ attachments().length > 10 ? '10+' : attachments().length }}</span>
        </div>
        <div class="inline-flex items-center gap-1.5"
            [ngClass]="{'!hidden': !show().includes('collaboratorsCount') || collabCount() === 0}">
            <app-svg name="users" [color]="ss.theme().color7" width="14" height="14"></app-svg>
            <span class="text-12-400 color-7">{{ collabCount() > 10 ? '10+' : collabCount() }}</span>
        </div>
        <div class="inline-flex items-center gap-1.5"
            [ngClass]="{'!hidden': !show().includes('access') || role() === 'owner'}">
            <app-svg [name]="role() === 'editor' ? 'edit' : 'view'" [color]="ss.theme().color7"
                width="12" height="12"></app-svg>
            <span class="text-12-400 color-7">{{ roleMap()[role() || 'viewer'] }}</span>
        </div>

    </div>
    <p class="text-12-400 color-7 mb-0 hashtags-block"
        [ngClass]="{'!hidden': !show().includes('hashtag') || ss.getValidHashtags(noteData().tags).length === 0 || role() !== 'owner'}">
        <span class="hashtag" *ngFor="let tagId of ss.getValidHashtags(noteData().tags)">#{{ss.tagMap()[tagId]}}</span>
    </p>
</div>